import type {
  PurchaseSetArtSerializer,
  IApiResponse,
  PurchaseSetSerializer,
  CreatePurchaseSetSerializer,
  PurchaseSetTotalSerializer,
  PurchaseSetBonusSerializer,
} from "@litres-libs/types";
import { rtkqApi } from "../api/rtkqApi";
import { standardRetryingRequestOptions } from "../api/retrying";

export type TemporalTypeForPurchaseSetResponse = IApiResponse<
  PurchaseSetArtSerializer[]
>["payload"] & {
  total_count: number;
};

export const purchaseSetApi = rtkqApi.injectEndpoints({
  endpoints: build => ({
    /**
     * Получить арты в наборе для покупки
     */
    getArtsInPurchaseSet: build.query<
      TemporalTypeForPurchaseSetResponse,
      {
        purchaseSetId: number;
        limit: number;
      }
    >({
      query: ({ purchaseSetId, limit }) => ({
        url: `/foundation/api/purchase-sets/${purchaseSetId}/arts?limit=${limit}&count=true`,
      }),
      transformResponse: (
        response: IApiResponse<PurchaseSetArtSerializer[]>
      ) => {
        return response.payload as TemporalTypeForPurchaseSetResponse;
      },
      extraOptions: {
        ...standardRetryingRequestOptions,
      },
    }),
    /**
     * Получить бонусы для покупки
     */
    getBonusesInPurchaseSet: build.query<
      PurchaseSetBonusSerializer,
      {
        purchaseSetId: number;
      }
    >({
      query: ({ purchaseSetId }) => ({
        url: `/foundation/api/purchase-sets/${purchaseSetId}/bonuses`,
      }),
      transformResponse: (
        response: IApiResponse<PurchaseSetBonusSerializer>
      ) => {
        return response.payload.data;
      },
    }),
    /**
     * Получить итоговую стоимость набора для покупки
     */
    getPurchaseSetPrices: build.query<
      PurchaseSetTotalSerializer,
      {
        purchaseSetId: number;
      }
    >({
      query: ({ purchaseSetId }) => ({
        url: `/foundation/api/purchase-sets/${purchaseSetId}`,
      }),
      transformResponse: (
        response: IApiResponse<PurchaseSetTotalSerializer>
      ) => {
        return response.payload.data;
      },
      extraOptions: {
        ...standardRetryingRequestOptions,
      },
    }),
    /**
     * Создать набор для покупки
     */
    createPurchaseSet: build.mutation<
      PurchaseSetSerializer,
      CreatePurchaseSetSerializer
    >({
      query: body => ({
        url: "/foundation/api/purchase-sets",
        method: "POST",
        body,
      }),
      transformResponse: (response: IApiResponse<PurchaseSetSerializer>) => {
        return response.payload.data;
      },
      extraOptions: {
        ...standardRetryingRequestOptions,
      },
    }),
  }),
});
